import React from 'react';
import { useFormContext } from 'react-hook-form';
import I18n from '@/modules/i18n';
import Pill from '@/components/ui/Pill';
import Text from '@/components/ui/Text';
import cn from '@/utils/cn';
import { NotifyStudentsClassroom } from './NotifyStudentsModal.utils';

interface StudentsCheckboxSectionProps {
  alreadyJoined: boolean;
  classroom: NotifyStudentsClassroom;
  student: NotifyStudentsClassroom['students'][0];
}

const StudentCheckbox = ({ alreadyJoined, classroom, student }: StudentsCheckboxSectionProps) => {
  const { register } = useFormContext();

  return (
    <label
      className={cn(
        'tw-flex tw-items-center tw-gap-3 tw-py-0.5',
        alreadyJoined ? 'tw-cursor-default' : 'tw-cursor-pointer',
      )}
    >
      <input
        disabled={alreadyJoined}
        type="checkbox"
        value={student.id}
        {...(alreadyJoined ? {} : register(classroom.id.toString()))}
      />
      <Text size="sm" weight="semibold">{`${student.first_name} ${student.last_name}`}</Text>
      {alreadyJoined && (
        <Pill pillClassName="tw-py-0.5" pillColor="grey">
          <Text size="sm">{I18n.t('notify_students_already_joined')}</Text>
        </Pill>
      )}
    </label>
  );
};

export default StudentCheckbox;
